import React from "react";
import { Box, Text } from "@origin-digital/ods-core";

export const AddressSection = ({ address }: { address: string }) => {
  return (
    <Box paddingLeft="xlarge">
      <Text>{address}</Text>
    </Box>
  );
};
